<div class="ngb-toasts">
    <ngb-toast *ngFor="let toast of toasts" [class]="getClassNames(toast)" [autohide]="true" [delay]="5000"
        (hidden)="remove(toast)">
        <i class="fas fa-exclamation-circle mr-2" *ngIf="toast.type == ToastTypes.Info"></i>
        <i class="fas fa-thumbs-up mr-2" *ngIf="toast.type == ToastTypes.Success"></i>
        <i class="fas fa-exclamation-triangle mr-2" *ngIf="toast.type == ToastTypes.Danger"></i>
        {{toast.message | translate}}
    </ngb-toast>
</div>